// extracted by mini-css-extract-plugin
export default {"warningIcon":"DeleteConfirmationModal_warningIcon__TYutN"};